import apiClient from '../api';
import { CheckInPhoto } from '../../types';

export const photoService = {
  /**
   * List photo metadata for a check-in.
   * Athletes see their own; coaches pass viewAs to see an athlete's.
   */
  getPhotos: async (metricId: string, viewAs?: string): Promise<CheckInPhoto[]> => {
    const params = viewAs ? `?viewAs=${viewAs}` : '';
    const response = await apiClient.get(`/metrics/${metricId}/photos${params}`);
    return response.data;
  },

  /**
   * Upload a photo for a check-in. Athletes only — coaches cannot upload.
   * Returns the saved photo metadata.
   */
  uploadPhoto: async (metricId: string, file: File): Promise<CheckInPhoto> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/metrics/${metricId}/photos`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /**
   * Download a photo via the authenticated proxy endpoint and return an
   * object URL that can be used in <img src>. The caller is responsible for
   * calling URL.revokeObjectURL() when the URL is no longer needed.
   *
   * Never exposes a public blob URL — the API always authenticates the request.
   */
  loadPhotoAsObjectUrl: async (photoId: string, viewAs?: string): Promise<string> => {
    const params = viewAs ? `?viewAs=${viewAs}` : '';
    const response = await apiClient.get(`/photos/${photoId}/content${params}`, {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data as Blob);
  },

  /**
   * Delete a photo. Athletes only — coaches cannot delete.
   */
  deletePhoto: async (photoId: string): Promise<void> => {
    await apiClient.delete(`/photos/${photoId}`);
  },
};
